export const seedVehicles = [
  { id: 'V1', name: 'Swift Dzire', brand: 'Maruti Suzuki', model: 'Dzire', category: 'Sedan', seats: 4, luggage: 2, fuel: 'Diesel', transmission: 'Manual', ac: true, rate: 12, rateUnit: '/km', deposit: 2000, driverCharge: 500, status: 'available', image_url: '/images/fleet/swift_dzire.webp', features: ['Music System', 'Charging Port', 'Bottled Water', 'Clean & Sanitized', 'AC & Heater'], booked: [] },
  { id: 'V2', name: 'Hyundai Aura', brand: 'Hyundai', model: 'Aura', category: 'Sedan', seats: 4, luggage: 2, fuel: 'Petrol', transmission: 'Manual', ac: true, rate: 12, rateUnit: '/km', deposit: 2000, driverCharge: 500, status: 'available', image_url: '/images/fleet/hyundai_aura.webp', features: ['Music System', 'Charging Port', 'Comfortable Legroom', 'AC & Climate Control', 'Dual Airbags'], booked: [] },
  { id: 'V3', name: 'Maruti Ertiga', brand: 'Maruti Suzuki', model: 'Ertiga', category: 'MUV / MPV', seats: 6, luggage: 3, fuel: 'Diesel', transmission: 'Manual', ac: true, rate: 14, rateUnit: '/km', deposit: 3000, driverCharge: 600, status: 'available', image_url: '/images/fleet/maruti_ertiga.webp', features: ['Spacious Cabin', 'Charging Port', 'Tissue Paper', 'Dual AC Vents', 'Luggage Carrier Space'], booked: [] },
  { id: 'V4', name: 'Toyota Innova Crysta', brand: 'Toyota', model: 'Innova Crysta', category: 'Premium SUV', seats: 7, luggage: 4, fuel: 'Diesel', transmission: 'Manual', ac: true, rate: 20, rateUnit: '/km', deposit: 5000, driverCharge: 800, status: 'available', image_url: '/images/fleet/innova_crysta.webp', features: ['Premium Comfort', 'Captain Seats', 'Charging Port', 'Pushback Seats', 'Highway Ride Quality'], booked: [] },
  { id: 'V5', name: 'Urbania', brand: 'Force', model: 'Urbania', category: 'Traveller', seats: 17, luggage: 0, fuel: 'Diesel', transmission: 'Manual', ac: true, rate: 25, rateUnit: '/km', deposit: 8000, driverCharge: 1000, status: 'available', image_url: 'https://azqrhmowzbvylogjpyon.supabase.co/storage/v1/object/public/fleet-images/vehicles/f5413879-5b8f-4fc1-9f8f-ba9424081149.jpeg', features: ['Group Travel', 'Comfortable Passenger Van'], booked: [] },
];

export const seedTourPackages = [
  { id: 'tour-golden-gujarat', name: 'Golden Gujarat Escape', package_type: 'tour', duration: '3 days / 2 nights', description: 'A comfortable private-car circuit through Gujarat highlights.', active: true },
  { id: 'tour-daman-silvassa', name: 'Daman & Silvassa Weekend', package_type: 'tour', duration: '2 days / 1 night', description: 'A relaxed coastal and nature break from Vapi.', active: true },
  { id: 'local-4-hour', name: 'Local 4 Hour Package', package_type: 'local', duration: '4 hours / 40 km', description: 'City rides, errands and appointments within the local area.', active: true },
  { id: 'local-8-hour', name: 'Local 8 Hour Package', package_type: 'local', duration: '8 hours / 80 km', description: 'A full-day local booking with flexible stops.', active: true },
];

export const seedTravelPlans = [
  { id: 'one_way', label: 'One Way', icon: 'ic-arrow-right', sort_order: 1, active: true },
  { id: 'round_trip', label: 'Round Trip', icon: 'ic-route', sort_order: 2, active: true },
  { id: 'local', label: 'Local', icon: 'ic-clock', sort_order: 3, active: true },
  { id: 'tour', label: 'Tour', icon: 'ic-map', sort_order: 4, active: true },
  { id: 'tempo', label: 'Tempo', icon: 'ic-users', sort_order: 5, active: true },
  { id: 'urbania', label: 'Urbania', icon: 'ic-truck', sort_order: 6, active: true },
];

export const seedServices = [
  {
    icon: 'ic-route',
    name: 'One-Way Cab Service',
    category: 'Outstation Plan',
    desc: 'Pay only for the distance you travel one-way between Vapi, Surat, Mumbai, Pune, Vadodara, and Ahmedabad — no return fare charges.'
  },
  {
    icon: 'ic-map',
    name: 'Round-Trip Outstation Tours',
    category: 'Outstation Plan',
    desc: 'Plan multi-day outstation road trips with a dedicated private vehicle and experienced driver who knows the best routes and food stops.'
  },
  {
    icon: 'ic-clock',
    name: 'Local Hourly Rentals (4h / 8h / 12h)',
    category: 'Local Package',
    desc: 'Flexible hourly packages perfect for city shopping, doctor visits, business meetings, and local sightseeing in Vapi, Daman, & Silvassa.'
  },
  {
    icon: 'ic-sparkle',
    name: 'Pilgrimage & Temple Tours',
    category: 'Tour Package',
    desc: 'Comfortable family tours to Somnath, Dwarka, Statue of Unity, Shirdi, Trimbakeshwar, and Palitana with convenient stops.'
  },
  {
    icon: 'ic-plane',
    name: 'Airport Pickup & Drop',
    category: 'Transfer Service',
    desc: '24/7 on-time transfers to Mumbai CSIA (BOM), Surat (STV), and Ahmedabad (AMD) airports with flight tracking & luggage help.'
  },
  {
    icon: 'ic-users',
    name: 'Group Travel & Tempo / Urbania',
    category: 'Group Travel',
    desc: 'Spacious 17-seater Tempo Travellers and luxury Urbania mini-buses for large family vacations, pilgrimages, and group tours.'
  },
  {
    icon: 'ic-heart',
    name: 'Wedding & Event Transportation',
    category: 'Events',
    desc: 'Decorated bridal cars, luxury SUVs, and coordinated guest shuttle fleets to ensure smooth transit for wedding guests.'
  },
  {
    icon: 'ic-briefcase',
    name: 'Corporate Mobility & VIP Travel',
    category: 'Corporate',
    desc: 'Reliable executive mobility, client visits, and monthly corporate cabs across Vapi, Sarigam, Umbergaon, and Surat GIDC hubs.'
  },
  {
    icon: 'ic-map',
    name: 'Weekend Getaway Packages',
    category: 'Tour Package',
    desc: 'Quick weekend road trips to coastal beaches in Daman, green nature spots in Silvassa, or hill stations in Saputara.'
  },
  {
    icon: 'ic-truck',
    name: 'Industrial & Plant Visit Shuttles',
    category: 'Industrial',
    desc: 'Point-to-point transport for industrial engineers, factory auditors, and business delegates traveling between plants.'
  },
  {
    icon: 'ic-doc',
    name: 'Long-Term Monthly Rentals',
    category: 'Long Term',
    desc: 'Cost-effective monthly car rentals for companies, project consultants, or individuals needing long-term personal mobility.'
  }
];

export const seedTestimonials = [
  { name: 'Ramesh Patel', rating: 5, review: 'Booked an Innova Crysta for our Mumbai airport transfer — clean car, driver was on time and very professional.', date: '2026-06-12' },
  { name: 'Priya Shah', rating: 5, review: 'Used Trishul for a family trip to Surat. Comfortable Ertiga and transparent billing, no hidden charges at all.', date: '2026-07-03' },
  { name: 'Karan Mehta', rating: 4, review: 'Reliable outstation service. Driver was courteous and the car was spotless. Will book again for our next trip.', date: '2026-07-20' },
];

export const seedFaqs = [
  { q: 'How can I book a vehicle?', a: 'Simply search your travel dates on our homepage, choose a vehicle from the Fleet page, and submit a booking request — or call/WhatsApp us directly.' },
  { q: 'What documents are required?', a: 'All bookings include a professional driver, so no driving licence is required from you.' },
  { q: 'Is advance payment required?', a: 'A partial advance may be requested to confirm select bookings; our team will share exact terms when confirming your trip.' },
  { q: 'Can I cancel my booking?', a: 'Yes, bookings can be cancelled as per our cancellation policy. Contact our support team for assistance.' },
  { q: 'Are vehicles available with drivers?', a: 'Yes, all our vehicles are provided with experienced, verified drivers.' },
  { q: 'Do you provide outstation rentals?', a: 'Absolutely — we serve outstation trips across India including one-way and round-trip journeys.' },
];

export const googleReviewsData = {
  summary: { average: 5.0, total: 5, breakdown: { 5: 5, 4: 0, 3: 0, 2: 0, 1: 0 } },
  reviews: [
    {
      name: 'Vishal Gautam',
      meta: '3 reviews · 9 photos',
      rating: 5,
      time: 'a month ago',
      text: 'Excellent service by Trishul Travels. Car was clean, driver was polite and professional. The journey was smooth and comfortable. Highly recommended for reliable travel service.'
    },
    {
      name: 'Vidhi Kansara',
      meta: '2 reviews',
      rating: 5,
      time: 'a month ago',
      text: 'Have a great experience & memorable trips. The staff is friendly & low pressure which is very appreciated. They have solid connections across the country — even great for long road trips. Would definitely recommend to all.'
    },
  ],
};
